import { Button, ListItem, ListItemButton, styled } from "@mui/material";
import theme from "../../theme";

export const MessageListItem = styled(ListItem)`
  display: flex;
  flex-direction: column;
`;

export const MessageItemButton = styled(ListItemButton)`
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  padding: 10px;
`;

export const UnstarButton = styled(Button)`
  background-color: ${theme.palette.action.active};
  border-radius: 7px;
  text-transform: none;
  height: 32px;
  font-size: 14px;
  color: ${theme.palette.common.white};
  margin-top: 8px;
  justify-content: flex-start;
`;
